import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import AvailableLeads from './components/AvailableLeads';
import TakenLeads from './components/TakenLeads';

export const MarketPlace = () => {
	return (
		<Paper sx={{ p: 2, pt: 1, borderRadius: 1 }}>
			<Stack spacing={5}>
				<AvailableLeads />
				<TakenLeads />
			</Stack>
		</Paper>
	);
};

export default MarketPlace;
